/** Team Member Card */
import {
  Card,
  CardContent,
  CardActionArea,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import React from 'react'

import ContentfulImage from '@aletheia/common/components/ContentfulImage'
import { IPerson, IOrganization } from '@aletheia/eafunds/contentful'

import { TeamMemberDialog } from './TeamMemberDialog'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column-reverse',
    },
    width: '100%',
  },
  card: {
    height: '100%',
  },
  photoWrapper: {
    textAlign: 'center',
  },
  photo: {
    borderRadius: '50%',
    [theme.breakpoints.only('xs')]: {
      maxWidth: '200px',
    },
  },
  textWrapper: {
    [theme.breakpoints.only('xs')]: {
      textAlign: 'center',
    },
  },
  personName: {
    marginBottom: 0,
  },
  jobTitle: {
    fontFamily: theme.typography.h1.fontFamily,
    color: theme.palette.grey[700],
  },
  actionIcon: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.h2.fontSize,
    marginLeft: -theme.spacing(1),
  },
  organizationName: {
    fontFamily: theme.typography.h1.fontFamily,
    color: theme.palette.primary.main,
  },
}))

type TeamMemberCardProps = {
  Person: IPerson
  jobTitle: string
  Organization?: IOrganization
  longJobTitle?: React.ReactNode
}

export const TeamMemberCard: React.FC<TeamMemberCardProps> = (cardProps) => {
  const classes = useStyles()
  const { Person, jobTitle, longJobTitle, Organization } = cardProps
  const { title, photo } = Person.fields
  const [open, setOpen] = React.useState(false)

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={() => setOpen(true)} className={classes.card}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={11}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4} className={classes.photoWrapper}>
                  <ContentfulImage
                    className={classes.photo}
                    image={photo}
                    widths={[190, 380]}
                    sizes="190px"
                    square
                  />
                </Grid>
                <Grid item xs={12} sm={7} className={classes.textWrapper}>
                  <Typography
                    className={classes.personName}
                    variant="h6"
                    component="h4"
                    gutterBottom
                  >
                    {title}
                  </Typography>
                  {Organization && (
                    <>
                      <Typography className={classes.organizationName}>
                        {Organization.fields.title}
                      </Typography>
                    </>
                  )}
                  <Typography className={classes.jobTitle}>
                    {jobTitle}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={1}>
              <ChevronRightIcon className={classes.actionIcon} />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
      <TeamMemberDialog
        open={open}
        onClose={() => setOpen(false)}
        Person={Person}
        Organization={Organization}
        jobTitle={longJobTitle || jobTitle}
      />
    </Card>
  )
}

export default TeamMemberCard
